$(document).ready(function () {
  $('.games-wrapper').slick({
    autoplay: true,
    dots: false,
    speed: 1000,
    autoplaySpeed: 1000,
    infinite: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: false,
    touchThreshold: 300,
    centerMode: true,
    // variableWidth: true,
    easing: 'linear',
    responsive: [
      {
        breakpoint: 821,
        settings: {
          slidesToShow: 5
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 531,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 431,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 361,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 348,
        settings: {
          slidesToShow: 2
        }
      },
    ]
  });

  $('.slider-prev').click(function () {
    $(this).closest('.section').find(".list").slick('slickPrev');
  });

  $('.slider-next').click(function () {
    $(this).closest('.section').find(".list").slick('slickNext');
  });
});
